import { configureStore } from '@reduxjs/toolkit'
import { bannerSlice } from './global-state/banner-slice'
import { investorSlice } from './global-state/investor-slice'
import phoneCollectionReducer from './global-state/phone-collection-slice'

const store = configureStore({
  reducer: {
    investor: investorSlice.reducer,
    banner: bannerSlice.reducer,
    phoneCollection: phoneCollectionReducer,
  },
})
export { store }
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
